module.exports = __webpack_public_path__ + "img/Desk Stationeryd07.c707c9d7.jpg";